<app-user-form
  (userDataChange)="updateUser($event)"
  [(userData)]="userData"
  [loading]="loading"
  [userFormType]="'save'"
></app-user-form>
